import styled from "@emotion/styled";
import { StyledSideBySideTextAndAsset } from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.scss";
export const StyledUsecasesGalleryTabsMobileComponent = styled.div`
  &.usecases-gallery-tabs-mobile-component {
    ${StyledSideBySideTextAndAsset} .image-wrapper {
      padding: 0 5px 0 !important;
    }
  }
`;
